// extracted by mini-css-extract-plugin
export default {"eventCover":"event-cover_eventCover__hR6hA","footer":"event-cover_footer__Mgl42"};